export default __webpack_public_path__ + "static/media/delete-16px.95ebd8c1.svg";